import React from 'react'
import NavbarContainer from '../Components/NavbarContainer/NavbarContainer'
import FinalExamContainer from '../Components/FinalExamContainer/FinalExamContainer'

function FinalExam() {
  return (
    <div>
      <NavbarContainer/>
      <FinalExamContainer/>
    </div>
  )
}

export default FinalExam
